import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import AuthUserContext from "../Session/context";
import { CMS_V2_BASE_URL, SIGN_IN } from "../../constants/routes";

const DeprecationNotice = () => {
  const authUser = useContext(AuthUserContext);
  const uid = authUser && authUser.uid;
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const dismissedUsers = useRef(new Set());
  const storageKey = `cms-v1-deprecation-dismissed:${uid}`;

  useEffect(() => {
    if (!uid || dismissedUsers.current.has(uid)) {
      setOpen(false);
      return;
    }

    try {
      setOpen(sessionStorage.getItem(storageKey) !== "true");
    } catch {
      setOpen(true);
    }
  }, [uid, storageKey]);

  const dismiss = () => {
    dismissedUsers.current.add(uid);
    setOpen(false);
    try {
      sessionStorage.setItem(storageKey, "true");
    } catch {
      // Keep dismissal in memory when browser storage is unavailable.
    }
  };

  return (
    <Dialog
      open={Boolean(uid && open && pathname !== SIGN_IN)}
      onClose={dismiss}
      fullWidth
      maxWidth="sm"
      aria-labelledby="cms-deprecation-title"
      aria-describedby="cms-deprecation-description"
    >
      <DialogTitle id="cms-deprecation-title">
        CMS v1 is being phased out
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="cms-deprecation-description">
          We’re transitioning to CMS v2. Please begin using the new CMS for your
          daily work.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={dismiss}>Continue in CMS v1</Button>
        {CMS_V2_BASE_URL && (
          <Button
            component="a"
            href={CMS_V2_BASE_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            color="primary"
            onClick={dismiss}
          >
            Open CMS v2
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DeprecationNotice;
